import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import {
    SystemModel,
    SystemModelPagedResponseModel,
    ApplicationSystemApiModel,
    QueryParams
} from '../models';

/**
 * Systems API Service
 */
@Injectable({
    providedIn: 'root'
})
export class SystemsService extends BaseApiService {

    /**
     * Get all systems with pagination
     */
    getSystems(params?: QueryParams): Observable<SystemModelPagedResponseModel> {
        return this.get<SystemModelPagedResponseModel>('/systems', params)
            .pipe(map(response => response.data!));
    }

    /**
     * Get system by ID
     */
    getSystemById(id: string): Observable<SystemModel> {
        return this.get<SystemModel>(`/systems/${id}`)
            .pipe(map(response => response.data!));
    }

    /**
     * Create new system
     */
    createSystem(system: SystemModel): Observable<SystemModel> {
        return this.post<SystemModel>('/systems', system)
            .pipe(map(response => response.data!));
    }

    /**
     * Update system
     */
    updateSystem(id: string, system: SystemModel): Observable<SystemModel> {
        return this.put<SystemModel>(`/systems/${id}`, system)
            .pipe(map(response => response.data!));
    }

    /**
     * Delete system
     */
    deleteSystem(id: string): Observable<void> {
        return this.delete<void>(`/systems/${id}`)
            .pipe(map(() => undefined));
    }

    /**
     * Get application systems
     */
    getApplicationSystems(): Observable<ApplicationSystemApiModel[]> {
        return this.get<ApplicationSystemApiModel[]>('/lookup/applications')
            .pipe(map(response => response.data!));
    }
}
